
import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {__,__n} from "i18n-for-browser";

/*
* Import Components
 */
import GoBackButton from "../elements/GoBackButton";
import GamePageContent from "../elements/GamePageContent";

/*
* Import helpers
 */
import { getPopupDeviceDifficulty, getPopupCurrentGame } from "../../helpers/popupHelper";

class GamePage extends Component {
  static defaultProps = {
    desktop: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      gameId: parseInt(props.match.params.gameid, 10)
    }
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
    this.curGame = getPopupCurrentGame(this.state.gameId);
  };

  getSubtitle = () => {
    const { project } = this.props;

    if (project.EducationProject.nameShort === 'GLXL') {
      return __('sim_globas_verdienen');
    } else {
      return __n('sim_spel', 0);
    }
  }

  render() {
    const { props: { schoolClass, desktop }, state: { gameId } } = this;
    const curGame = schoolClass.SchoolClassGames.find(game => game.GameId === gameId);

    if ((!curGame) || (curGame.Game.softwareLocation !== null)) {
      return (
        <div className={'error-page container'}>
          <GoBackButton history={this.props.history} />
          <p>{__('sim_standaard_foutmelding')}</p>
        </div>
      )
    }

    return (
      <div className={'gamepage portal-home ' + (desktop ? ' darkBckg desktop-single' : '')}>
        <div className={`container ${desktop ? ' general-materials-container' : ''}`}>
          <div className={'title-block title-portal'}>
            <GoBackButton history={this.props.history} />
            <h3>{curGame.Game.name}</h3>
            <p>{this.getSubtitle()}</p>
          </div>
          {curGame.Game ? <GamePageContent game={curGame} /> : null}
        </div>
      </div>
    )
  }
}

export default connect(state => ({
  user: state.user,
  group: state.group,
  project: state.project,
  schoolClass: state.schoolClass,
  gameState: state.gameState,
}))(GamePage);



// WEBPACK FOOTER //
// ./src/components/routes/GamePage.js